import {
  CUSTOMER_APPROVAL_LIST_REQUEST,
  CUSTOMER_APPROVAL_LIST_SUCCESS,
  CUSTOMER_APPROVAL_LIST_FAILED,
  CUSTOMER_APPROVAL_UPDATE_REQUEST,
  CUSTOMER_APPROVAL_UPDATE_SUCCESS,
  CUSTOMER_APPROVAL_UPDATE_FAILED,
  CUSTOMER_APPROVAL_REJECT_REQUEST,
  CUSTOMER_APPROVAL_REJECT_SUCCESS,
  CUSTOMER_APPROVAL_REJECT_FAILED,
  CUSTOMER_APPROVAL_STATE_CHANGE,
  CUSTOMER_APPROVAL_DELETE_REQUEST,
  CUSTOMER_APPROVAL_DELETE_SUCCESS,
  CUSTOMER_APPROVAL_DELETE_FAILED,
  PROPERTY_LIST_REQUEST,
  PROPERTY_LIST_SUCCESS,
  PROPERTY_LIST_FAILED,
  ADD_NEW_PROPERTY_REQUEST,
  ADD_NEW_PROPERTY_SUCCESS,
  ADD_NEW_PROPERTY_FAILED,
  CUSTOMER_PROPERTY_DELETE_REQUEST,
  CUSTOMER_PROPERTY_DELETE_SUCCESS,
  CUSTOMER_PROPERTY_DELETE_FAILED,
  CUSTOMER_ROLE_UPDATE_REQUEST,
  CUSTOMER_ROLE_UPDATE_SUCCESS,
  CUSTOMER_ROLE_UPDATE_FAILED
} from "../../../_utils/constants/CustomerApproval";

const initialState = {
  customerApprovalList: [],
  customerUpdationData: [],
  customerRejectedData: [],
  isLoading: false,
  errors: {},
  customerDeletedData: [],
  customerExistData: [],
};

const CustomerApprovalReducer = (state = initialState, action) => {
  switch (action.type) {
    case CUSTOMER_APPROVAL_LIST_REQUEST:
      return {
        ...state,
        isLoading: true,
        errors: {}
      }
    case CUSTOMER_APPROVAL_LIST_SUCCESS:
      var decryptedData = action.payload;
      return {
        ...state,
        customerApprovalList: decryptedData.result,
        isLoading: false,
        errors: {}
      }
    case CUSTOMER_APPROVAL_LIST_FAILED:
      return {
        ...state,
        isLoading: false,
        errors: action.payload
      }
    case PROPERTY_LIST_REQUEST:
      return {
        ...state,
        isLoading: true,
        errors: {}
      }
    case PROPERTY_LIST_SUCCESS:
      var decryptedData = action.payload;
      return {
        ...state,
        propertyList: decryptedData.result,
        isLoading: false,
        errors: {}
      }
    case PROPERTY_LIST_FAILED:
      return {
        ...state,
        isLoading: false,
        errors: action.payload
      }
    case ADD_NEW_PROPERTY_REQUEST:
      return {
        ...state,
        isLoading: true,
        errors: {}
      }
    case ADD_NEW_PROPERTY_SUCCESS:
      var decryptedData = action.payload;
      return {
        ...state,
        propertyUpdatedData: decryptedData.result,
        isLoading: false,
        errors: {}
      }
    case ADD_NEW_PROPERTY_FAILED:
      return {
        ...state,
        isLoading: false,
        errors: action.payload
      }
    case CUSTOMER_PROPERTY_DELETE_REQUEST:
      return {
        ...state,
        isLoading: true,
        errors: {}
      }
    case CUSTOMER_PROPERTY_DELETE_SUCCESS:
      return {
        ...state,
        propertyDeletedData: action?.payload?.result,
        isLoading: false,
        errors: {}
      }
    case CUSTOMER_PROPERTY_DELETE_FAILED:
      return {
        ...state,
        isLoading: false,
        errors: action.payload
      }
    case CUSTOMER_APPROVAL_UPDATE_REQUEST:
      return {
        ...state,
        isLoading: true,
        // Reset the transient "email already exists" message so approving
        // another row re-triggers the toast even when the API returns the
        // same error string again (the component watches this value).
        customerExistData: null,
        errors: {}
      }
    case CUSTOMER_APPROVAL_UPDATE_SUCCESS:
      return {
        ...state,
        customerUpdationData: action?.payload?.result,
        customerExistData: action?.payload?.error,
        isLoading: false,
        errors: {}
      }
    case CUSTOMER_APPROVAL_UPDATE_FAILED:
      return {
        ...state,
        isLoading: false,
        errors: action.payload
      }
    case CUSTOMER_APPROVAL_REJECT_REQUEST:
      return {
        ...state,
        isLoading: true,
        errors: {}
      }
    case CUSTOMER_APPROVAL_REJECT_SUCCESS:
      return {
        ...state,
        customerRejectedData: action?.payload?.result,
        isLoading: false,
        errors: {}
      }
    case CUSTOMER_APPROVAL_REJECT_FAILED:
      return {
        ...state,
        isLoading: false,
        errors: action.payload
      }
    case CUSTOMER_APPROVAL_DELETE_REQUEST:
      return {
        ...state,
        isLoading: true,
        errors: {}
      }
    case CUSTOMER_APPROVAL_DELETE_SUCCESS:
      return {
        ...state,
        customerDeletedData: action?.payload?.result,
        isLoading: false,
        errors: {}
      }
    case CUSTOMER_APPROVAL_DELETE_FAILED:
      return {
        ...state,
        isLoading: false,
        errors: action.payload
      }
    case CUSTOMER_ROLE_UPDATE_REQUEST:
      return {
        ...state,
        isLoading: true,
        errors: {}
      }
    case CUSTOMER_ROLE_UPDATE_SUCCESS:
      return {
        ...state,
        customerRoleUpdatedData: action?.payload?.result,
        isLoading: false,
        errors: {}
      }
    case CUSTOMER_ROLE_UPDATE_FAILED:
      return {
        ...state,
        isLoading: false,
        errors: action.payload
      }
    case CUSTOMER_APPROVAL_STATE_CHANGE:
      return {
        ...state,
        customerUpdationData: [],
        customerRejectedData: [],
        customerRejectedData: [],
        isLoading: false,
        errors: {},
      }
    }
  return state;
};

export default CustomerApprovalReducer;